export default "__VITE_ASSET__CWAa9KXx__"